var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon, _path11, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 500",
    style: {
      enableBackground: "new 0 0 700 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "var(--background-color-lighter, #F5F5FF)"
    },
    cx: 289.02,
    cy: 220.777,
    rx: 232.754,
    ry: 165.915
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DFDFEB"
    },
    cx: 540.283,
    cy: 439.709,
    rx: 106.251,
    ry: 14.741
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DFDFEB"
    },
    cx: 317.581,
    cy: 446.822,
    rx: 191.948,
    ry: 16.346
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--button-color-primary, #7E9E6E)"
    },
    d: "M354.278,157.1c0,0-3.552,20.617-29.434,47.155c0,0-2.86-3.54,2.089-18.207 C331.881,171.381,352.802,152.106,354.278,157.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M354.278,157.1 c0,0-23.29,16.659-29.434,47.155c0,0-1.191,10.458,2.393,19.52"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--button-color-primary, #7E9E6E)"
    },
    d: "M291.678,173.754c0,0,6.534-4.951-4.707-17.316c-10.678-11.747-21.983-22.279-44.079-26.139 c0,0,6.669,29.929,21.067,37.063C278.357,174.496,291.678,173.754,291.678,173.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--button-color-primary, #7E9E6E)"
    },
    d: "M238.046,195.761c0,0,23.053,5.029,62.152-8.019c0,0-2.424-4.042-19.895-5.401 C262.832,180.981,233.496,192.402,238.046,195.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M238.046,195.761 c0,0,27.659-14.642,62.152-8.019c0,0,3.548,0.888,7.161,5.714"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--button-color-primary, #7E9E6E)"
    },
    d: "M257.154,216.648c0,0,24.67,16.239,63.768,3.192c0,0-7.604-13.755-25.074-15.115 C278.377,203.365,252.603,213.289,257.154,216.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M257.154,216.648 c0,0,26.59-12.407,63.768,3.192c0,0,4.372,1.946,7.985,6.772"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.658,137.578c0,0,7.281-0.872-10.486,15.563c-16.777,15.52-14.644,15.641-14.644,15.641 S321.894,145.559,340.658,137.578z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--button-color-primary, #7E9E6E)"
    },
    d: "M303.323,176.643c0,0,5.438,2.097,15.246-6.904c9.808-9.001,13.464-29.061,22.089-32.161 C340.658,137.578,319.02,144.568,303.323,176.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M338.985,245.566 c-11.063-22.284-26.422-47.6-47.307-71.811c0,0-5.131-6.719-22.956-24.138c-17.825-17.419-25.83-19.317-25.83-19.317"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M338.103,138.646 c0,0-20.59,8.985-34.779,37.997c-3.437,7.029,0.675,12.591,4.036,16.813"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--button-color-primary, #7E9E6E)"
    },
    d: "M525.859,379.153c0,0-17.209,12.699-56.862,3.379c0,0,0.105-6.36,14.336-12.477 C497.565,363.937,528.109,373.263,525.859,379.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M524.629,377.995 c0,0-27.158-9.077-55.454,3.849c0,0-9.166,5.175-14.398,13.396"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--button-color-primary, #7E9E6E)"
    },
    d: "M468.48,351.215c0,0,7.844,2.383,11.256-13.975c3.242-15.54,5.134-30.875-4.712-51.03 c0,0-20.316,22.967-17.64,38.811C460.06,340.866,468.48,351.215,468.48,351.215z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M526.807,357.347c0,0,6.052,4.14-18.142,4.802c-22.845,0.626-21.321,2.122-21.321,2.122S507.431,350.991,526.807,357.347z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--button-color-primary, #7E9E6E)"
    },
    d: "M472.984,362.147c0,0,2.71,5.16,16.019,4.848c13.309-0.312,29.274-12.996,37.805-9.648 C526.807,357.347,505.922,348.353,472.984,362.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M438.111,431.667 c11.548-22.037,23.027-49.332,30.369-80.452c0,0,2.428-8.098,6.067-32.754c3.639-24.656,0.477-32.251,0.477-32.251"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M524.181,356.467 c0,0-21.41-6.803-51.197,5.679c-7.216,3.024-9.264,7.799-12.314,16.651"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--text-color-heading, #333969)"
    },
    d: "M251.612,232.331c-5.57,0-10.962-1.954-15.239-5.523l-11.865-9.901 c-4.27-3.563-9.342-5.472-14.538-5.472h-58.887c-5.344,0-9.676,4.332-9.676,9.676v11.22V434.3c0,9.221,7.475,16.696,16.696,16.696 h293.551c7.172,0,12.986-5.814,12.986-12.987V245.318c0-7.172-5.814-12.986-12.986-12.986H251.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--button-background-color-primary, #7584F1)"
    },
    d: "M464.639,439.097c0,0-19.978-37.474-21.976-41.778l-54.599-111.232 c-1.372-2.956-4.335-4.847-7.594-4.847H177.576c-7.376,0-18.044-3.866-23.708-8.592l-8.187-6.832 c-4.27-3.563-9.342-5.472-14.538-5.472H75.102c-5.965,0-10.017,6.06-7.738,11.572l67.766,163.899 c3.799,9.187,12.76,15.179,22.701,15.179h303.143c1.976,0,3.801-1.693,3.8-3.669L464.639,439.097z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "var(--button-color-primary, #000000)",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 382.112,
    y1: 291.818,
    x2: 462.23,
    y2: 447.559
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "var(--button-color-primary, #000000)",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M349.099,318.656h-69.013 c-1.882,0-3.633-0.947-4.644-2.51v0c-2.332-3.608,0.3-8.331,4.644-8.331h69.013c1.882,0,3.633,0.947,4.644,2.51l0,0 C356.075,313.934,353.443,318.656,349.099,318.656z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "var(--button-color-primary, #000000)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 220.002,
    y1: 372.184,
    x2: 273.735,
    y2: 404.197
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "var(--button-color-primary, #000000)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 263.935,
    y1: 370.641,
    x2: 230.171,
    y2: 404.39
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2666 -0.9638 0.9638 0.2666 -193.3339 521.7817)",
    style: {
      fill: "none",
      stroke: "var(--button-color-primary, #000000)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 246.202,
    cy: 387.933,
    rx: 30.525,
    ry: 40.403
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M524.377,232.436c1.289-5.57-4.638-12.514-10.249-11.419c-4.568,0.891-6.842,1.986-7.575,2.228 c-1.435,0.473-12.143-0.224-13.369,1.56c-0.888,1.292,4.698,2.784,8.271,3.139c0.736,0.073,0.953,1.035,0.324,1.424 c-3.511,2.177-10.501,6.602-11.095,7.695c-0.797,1.465-4.428,7.162-3.405,7.794c1.023,0.633,4.117-2.213,6.127-4.233 c2.011-2.02,7.886-3.738,7.886-3.738s-10.215,10.253-11.562,13.096c-2.005,4.233,3.813,2.377,3.813,2.377 c-0.911,2.392,3.861,1.868,4.989,0.965c2.228-1.783,9.115-10.093,9.135-9.247c0.02,0.847-7.115,9.902-6.392,12.017 c0.723,2.115,3.609-0.539,5.278-2.77c1.67-2.231,6.573-8.467,6.573-8.467s5.57-4.066,10.22-11.089 C523.383,233.712,524.362,232.502,524.377,232.436z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 493.797,
    y1: 252.129,
    x2: 503.544,
    y2: 240.513
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--button-color-primary, #9EC68A)"
    },
    d: "M451.104,199.487l35.062-21.875c0.217-0.142,0.424-0.299,0.62-0.47l11.562-11.897 c2.517-2.206,6.399-1.692,8.255,1.093l5.667,8.5c1.2,1.8,1.242,4.134,0.107,5.976l-8.138,13.203 c-0.599,0.972-1.476,1.731-2.525,2.181c-6.547,2.804-31.561,13.369-46.481,17.584c-3.705,1.047-7.306-1.969-6.982-5.806 l0.366-4.321C448.76,201.956,449.677,200.419,451.104,199.487z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M531.854,418.06L530,430.656c0,0-34.743,13.346-31.52,13.539c3.223,0.193,53.151-2.712,53.151-2.712l-2.938-22.867 L531.854,418.06z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#424242",
      strokeMiterlimit: 10
    },
    d: "M541.532,214.226c0,0,2.769,26.648,4.845,28.032 c2.076,1.384,4.845,2.076,4.845,2.076l-4.499-30.454L541.532,214.226z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M596.396,195.91c0,0,14.082,28.676,9.994,44.653l-78.062-10.738l1.629-29.791L596.396,195.91z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#424242",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M598.54,201.719 c0,0-11.034,20.433-32.148,22.067"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#424242",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M580.877,219.427 c0,0,4.277,13.245,16.694,13.518"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M528.328,229.825c0,0-20.914,74.457-21.456,98.427l15.281,92.343c0,0,14.577,7.248,29.76,1.391 c0.622-0.24-7.697-47.894-8.282-96.96l43.644-91.319L528.328,229.825z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M606.734,237.439l-3.074,89.85l34.377,93.935c0,0-14.385,12.153-32.556,1.092l-37.322-89.444l3.828-65.081l-16.265-9.849 l-2.423-28.187L606.734,237.439z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "546.324,221.017 562.896,233.503 586.653,206.98 528.945,215.224 543.066,233.949  "
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M613.746,416.541l-2.999,10.867c0,0-21.918,23.773-18.688,23.773c3.23,0,39.222-14.716,39.222-14.716l-4.614-22.641 L613.746,416.541z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#424242",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M593.591,208.62 c0,0,9.48,23.303,2.65,121.054c0,0,23.943,52.695,36.358,94.374"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#424242",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "558.75,260.272 534.855,326.831  545.102,424.048  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M454.536,212.628c0,0,0.464,2.331-4.697,4.111c-5.161,1.78-8.198,1.215-8.198,1.215 s-11.578-13.656-12.092-14.138c-0.514-0.483,0.361-5.734,3.786-7.837c2.08-1.277,10.146,0.805,16.162,2.637 c4.194,1.277,6.782,5.478,6.077,9.805C455.298,210.122,454.952,211.699,454.536,212.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M445.04,209.004c0,0-9.466-1.374-13.466-4.672c0,0-5.978-1.205-7.249-0.451 c-1.27,0.754-2.311,1.825-5.06,2.289c-2.749,0.464-1.92-1.367,0.968-3.963c0.825-0.742,3.033-3.409,4.947-3.77 c2.577-0.485,8.154-2.458,8.154-2.458l11.19,13.378"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M441.641,217.954c0,0-3.838,2.408-5.188,2.342c-1.35-0.065-2.625-0.87-2.955-3.088 c0,0-7.148,1.312-4.883-4.097c0,0-4.318-0.7-4.433-3.518c0,0-3.835-1.911-2.996-4.974c0.838-3.064,12.871-2.786,12.871-2.786 l12.768,6.482L441.641,217.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1A1C30",
      strokeWidth: 0.7799,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M438.93,218.466c0,0,3.646-3.233,3.443-4.53c-0.203-1.297-0.888-2.01-1.716-1.761c-1.11,0.333-5.337,3.556-7.159,5.033"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1A1C30",
      strokeWidth: 0.7799,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M428.615,213.111c0,0,9.712-1.516,9.802-2.955c0.09-1.439-0.589-3.337-2.617-2.933c-2.411,0.48-9.324,2.136-11.617,2.091"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1A1C30",
      strokeWidth: 0.7799,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M440.657,212.175c0,0,1.785-1.108,1.079-2.346c-0.706-1.238-1.67-1.673-3.736-1.136"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1A1C30",
      strokeWidth: 0.7799,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M423.987,205.258c0,0,0.531-0.691,1.282-1.397"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--text-color-heading, #333969)"
    },
    d: "M445.048,223.266l-0.167,0.094c-1.308,0.736-2.965,0.272-3.7-1.036l-25.248-44.894l4.903-2.757 l25.248,44.894C446.82,220.874,446.356,222.53,445.048,223.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--text-color-heading, #333969)"
    },
    d: "M428.414,184.645l2.119,3.768c0.575,1.022,0.315,2.259-0.581,2.762l-4.578,2.575 c-0.896,0.504-2.087,0.083-2.662-0.938l-2.211-3.931"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--text-color-heading, #333969)"
    },
    d: "M418.618,147.775c-8.758-16.247-19.736-27.431-26.713-27.954l0.231-1.543l-3.646,2.377 c-6.266,4.267-2.936,23.328,7.438,42.573c10.374,19.245,23.863,31.387,30.129,27.12l3.428-2.285l-0.987-1.321 C430.909,179.287,427.146,163.597,418.618,147.775z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8868 -0.4621 0.4621 0.8868 -24.2528 207.2254)",
    style: {
      fill: "var(--button-background-color-primary, #7584F1)"
    },
    cx: 410.919,
    cy: 153.124,
    rx: 13.643,
    ry: 39.616
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--background-color-lighter-200, #D3DDF7)"
    },
    d: "M418.802,147.756c8.443,15.663,11.757,30.763,7.404,33.728 c-4.354,2.965-14.727-7.328-23.17-22.991c-8.443-15.663-11.757-30.763-7.404-33.728 C399.986,121.8,410.359,132.093,418.802,147.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M445.04,209.004c0,0-9.466-1.374-13.466-4.672c0,0-5.978-1.205-7.249-0.451 c-1.27,0.754-2.311,1.825-5.06,2.289c-2.749,0.464-1.92-1.367,0.968-3.963c0.825-0.742,3.033-3.409,4.947-3.77 c2.577-0.485,8.154-2.458,8.154-2.458l11.19,13.378"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1A1C30",
      strokeWidth: 0.7799,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M445.04,209.004c0,0-9.466-1.374-13.466-4.672c0,0-5.978-1.205-7.249-0.451c-1.27,0.754-2.311,1.825-5.06,2.289"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--text-color-heading, #333969)"
    },
    d: "M418.802,147.756c-8.443-15.663-18.816-25.956-23.17-22.991c-0.344,0.234-0.634,0.552-0.884,0.932 c5.033,0.306,13.836,9.863,21.18,23.487c7.776,14.426,11.196,28.366,8.287,32.796c0.753,0.046,1.423-0.111,1.989-0.496 C430.559,178.519,427.244,163.418,418.802,147.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M412.924,141.617c4.491,8.332,6.254,16.365,3.938,17.942c-2.316,1.577-7.834-3.898-12.325-12.23 c-4.491-8.332-6.254-16.365-3.938-17.942C402.914,127.81,408.433,133.285,412.924,141.617z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--button-color-primary, #9EC68A)"
    },
    d: "M580.859,168.434l-6.965-24.852c-2.557-9.123-7.038-17.565-12.96-24.961 c-10.489-13.102-38.041-11.91-38.041-11.91l-21.198,15.253c-0.065,0.035-0.13,0.071-0.195,0.107 c-12.481,6.887-14.774,17.511-14.446,33.886l0.773,22.111l14.35-13.704l3.622,4.966c-0.016-0.143-0.03-0.276-0.042-0.405 l1.715,2.7l-1.673-2.294c0.508,4.562,2.887,16.18,13.947,21.608l6.301,9.915l-1.671,13.703 c59.135,21.504,73.862-20.721,73.862-20.721L580.859,168.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M499.144,162.084l7.743,9.469 c0,0-1.058,14.594,13.647,19.273"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--button-color-primary, #9EC68A)"
    },
    d: "M557.91,181.357l-45.008,39.215c0,0,8.912,12.477,12.923,12.923l53.92-34.313"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M526.271,208.54 c0,0,24.509-27.629,32.976-31.639"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M546.268,151.556 c0,0,1.17,6.183,9.024,27.907"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M532.064,229.93 c0,0,50.355-32.085,50.801-41.443c0.446-9.358-12.7-52.806-12.7-52.806"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M537.578,184.476 c0,0,12.12,1.141,15.875-9.859"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M488.497,176.285 c0,0,3.342-3.342,6.684,0.446"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M448.844,198.346l7.13-3.342c0,0,8.69,9.469,5.57,17.602l-8.69,2.562 C452.855,215.169,456.865,206.256,448.844,198.346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M515.743,215.558c0,0,9.358,4.011,16.042,15.541l-7.186,5.515c0,0-8.857-12.7-15.04-14.706 L515.743,215.558z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M507.889,105.267l29.522,2.172c0,0,1.119,16.239-16.709,30.56l-8.006-7.779l-4.362,9.471 c0,0-6.775-3.811-7.688-14.75l1.439-13.281L507.889,105.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M522.894,106.71c1.077,0.918,1.588,2.332,1.338,3.725c-0.948,5.285-3.814,18.077-9.56,19.684 c-7.267,2.033-11.799-12.318-11.799-12.318l3.623-25.067L522.894,106.71z"
  }), /*#__PURE__*/React.createElement("g", null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M499.873,112.654l-0.089,3.65c-0.068,0.037-1.309,10.812,2.312,11.227c15.134-2.736,16.086-17.085,17.381-31.325 C519.477,96.207,498.404,109.811,499.873,112.654z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M474.678,85.777c0,0-3.688,35.148,18.147,41.196c21.836,6.049,27.067-29.561,26.314-41.876 c-0.753-12.315-6.242-16.895-21.546-17.447C474.951,66.834,474.678,85.777,474.678,85.777z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M494.295,102.76c0.062,1.265-0.539,2.324-1.343,2.365c-0.804,0.041-1.506-0.952-1.568-2.217 c-0.062-1.265,0.539-2.324,1.343-2.365C493.531,100.503,494.233,101.495,494.295,102.76z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M496.693,96.285 c0,0-7.214,3.14-7.922-2.314"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M480.017,96.299 c0,0-2.383,4.137-5.123,2.299"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M476.184,103.647 c0,0,1.363-0.44,3.363,0.616"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M497.564,116.758 c0,0,1.967-1.881,3.591-2.309"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M482.805,107.697 c0,0-1.254,2.85,1.938,4.218"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M474.422,93.334c0,0,0.37-10.292,4.93-16.107c0,0,6.27,14.251,33.289,17.158l7.866-1.653c0,0,3.221-16.502-8.066-23 c-11.286-6.498-28.559-2.907-34.116,2.936C468.905,82.572,474.422,93.334,474.422,93.334z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "507.397,92.504 512.071,101.738 515.377,91.364  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9C7F"
    },
    d: "M523.734,100.779c-1.346,4.912-5.211,8.159-8.631,7.253c-3.42-0.906-5.102-5.623-3.755-10.535 c1.346-4.912,5.211-8.159,8.631-7.253C523.399,91.15,525.08,95.867,523.734,100.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M520.301,96.502 c0,0-3.847-3.31-5.949,2.742c0,0,2.247,2.385,0.829,4.257c0,0,2.215,0.503,3.308-1.451"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M518.636,98.817 c0,0-0.214-1.345-1.708-2.879"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M520.507,107.866c0,1.842-1.493,3.335-3.335,3.335s-3.335-1.493-3.335-3.335 c0-1.842,1.493-3.335,3.335-3.335S520.507,106.024,520.507,107.866z"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M511.159,74.035c0,0,4.104-21.433,13.681-17.329c9.576,4.104,13.909,24.625,4.788,26.221 c-9.12,1.596-16.189-2.736-16.189-2.736L511.159,74.035z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M511.273,80.191 c0,0,15.847,13.225,20.977,1.026"
  }))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#424242",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 571.16,
    y1: 267.285,
    x2: 552.816,
    y2: 256.933
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--background-color-lighter-200, #D3DDF7)"
    },
    d: "M154.786,131.333c19.821,0.54,36.221,16.416,37.362,36.212c0.671,11.64-3.84,22.232-11.432,29.705 c-1.122,1.104-1.643,2.678-1.381,4.23l2.851,16.871l-17.542-10.221c-0.999-0.582-2.176-0.796-3.31-0.567 c-4.288,0.865-8.831,1.024-13.514,0.315c-17.329-2.625-30.849-16.971-32.447-34.425 C113.243,150.19,131.824,130.707,154.786,131.333z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.954,183.149l-0.108-9.205c1.343-0.327,2.568-0.753,3.676-1.28c1.107-0.526,2.079-1.134,2.914-1.825 c0.835-0.689,1.534-1.461,2.098-2.315c0.563-0.853,0.988-1.77,1.28-2.75c0.29-0.98,0.436-2.015,0.436-3.105 c0-1.561-0.382-3.032-1.145-4.412c-0.762-1.379-1.852-2.496-3.268-3.35c-1.416-0.853-3.104-1.28-5.065-1.28 c-2.106,0-4.058,0.582-5.855,1.743c-1.798,1.163-3.169,3.141-4.112,5.937l-0.98-0.654c0.835-2.65,2.233-4.684,4.194-6.1 c1.961-1.417,4.193-2.125,6.699-2.125c2.143,0,4.021,0.455,5.638,1.362c1.615,0.908,2.877,2.134,3.785,3.677 c0.907,1.543,1.362,3.277,1.362,5.202c0,1.453-0.245,2.814-0.735,4.085c-0.49,1.271-1.181,2.433-2.07,3.486 c-0.89,1.054-1.97,1.97-3.241,2.751c-1.271,0.782-2.705,1.371-4.303,1.77l-0.108,8.388H151.954z M151.301,190.012 c0-0.472,0.127-0.862,0.381-1.171c0.254-0.308,0.6-0.463,1.035-0.463c0.508,0,0.871,0.146,1.09,0.436 c0.218,0.291,0.326,0.69,0.326,1.198c0,0.436-0.118,0.817-0.354,1.144c-0.237,0.327-0.591,0.49-1.063,0.49 c-0.473,0-0.826-0.146-1.063-0.436C151.418,190.92,151.301,190.521,151.301,190.012z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#424242",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M598.721,201.355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/NotFound.21e5cdf6830fdecfe617897b70355954.svg";
export { ForwardRef as ReactComponent };